import React from 'react';
import PropTypes from 'prop-types';

/**
 * Replaces the page-title section from the main blade template
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PageTitle = (props) => {
    const getFilterComponentClassNames = (key) => {
        return `cell small-${12 / props.filterComponents.length} ${key>0 ? 'padding-left-half' : ''}`
    }

    const getFilterComponentLayout = (components) => {
        return (
            <div className="grid-x">
                {Object
                    .keys(components)
                    .map(key => <React.Fragment key={key}>
                        <div className={getFilterComponentClassNames(key)}>
                            {components[key]}
                        </div>
                    </React.Fragment>)
                }
            </div>
        );
    }

    const getButtonComponentLayout = (components, alignment) => {
        return (
            <div className={`button-group align-${alignment} small-on-mobile`}>
                {Object
                    .keys(components)
                    .map(key => <React.Fragment key={key}>
                        {components[key]}
                    </React.Fragment>)
                }
            </div>
        );
    }

    const getTopRightComponents = () => {
        if (props.buttonComponents && !props.buttonsBelowTitle) {
            return getButtonComponentLayout(props.buttonComponents, 'right');
        } else {
            return props.topRightComponents
        }
    }

    const hasTopRightComponents = () => {
        if (props.buttonComponents && !props.buttonsBelowTitle) {
            return !!props.buttonComponents.length;
        } else {
            return !!props.topRightComponents
        }
    }

    const getBottomLeftComponents = () => {
        // Show the button components on the bottom left if buttonsBelowTitle = true. Might need a rethink
        if (props.buttonComponents && props.buttonsBelowTitle) {
            return getButtonComponentLayout(props.buttonComponents, 'left');
        } else {
            return (<>
                {Object
                    .keys(props.bottomLeftComponents)
                    .map(key => <React.Fragment key={key}>
                        {props.bottomLeftComponents[key]}
                    </React.Fragment>)
                }
            </>)
        }
    }

    const getBottomRightComponents = () => {
        if (props.filterComponents) {
            return getFilterComponentLayout(props.filterComponents);
        } else {
            return props.bottomRightComponents;
        }
    }

    const getBottomLeftColumns = () => {
        if (props.buttonsBelowTitle) {
            return 'small-12 medium-6 large-6';
        } else {
            return `small-12 medium-3 large-${12-props.bottomRightColumnSize}`;
        }
    }

    const getBottomRightColumns = () => {
        if (props.buttonsBelowTitle) {
            return 'small-12 medium-6 large-6';
        } else {
            return `small-12 medium-9 large-${props.bottomRightColumnSize}`;
        }
    }

    return (<>
        <section className="grid-x title-top">
            <div className={`cell small-12 ${(hasTopRightComponents()) ? `large-${12 - props.topRightColumnSize}` : ''}`}>
                <h1 style={{marginBottom: 0}}>
                    {props.title}
                    {props.titleAction}
                </h1>
            </div>

            {(hasTopRightComponents()) &&
                <div className={`cell small-12 large-${props.topRightColumnSize}`}>
                    {getTopRightComponents()}
                </div>
            }
        </section>

        {(props.introComponents) && (
            <section className="">
                {props.introComponents}
            </section>
        )}

        <section className="grid-x title-bottom">
            <div className={`cell ${getBottomLeftColumns()}`}>
                {getBottomLeftComponents()}
            </div>

            <div className={`cell ${getBottomRightColumns()}`}>
                {getBottomRightComponents()}
            </div>
        </section>
    </>)
}

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    buttonsBelowTitle: PropTypes.bool
}

PageTitle.defaultProps = {
    titleAction: null,
    topRightComponents: [],
    bottomLeftComponents: [],
    bottomRightComponents: [],
    buttonsBelowTitle: false, // Display the buttons below the title
    topRightColumnSize: 6,
    bottomRightColumnSize: 10,
}

export default PageTitle;
